export const APP_VERSION = 'v1.36.499';
